import 'leaflet/dist/leaflet.css';
import { ReactNode } from 'react';

export interface ConsoleBindCardProps {
    onClick: () => void;
}

function ConsoleBindCard({ onClick }: ConsoleBindCardProps): ReactNode {
    return (
        <div className='console-bind-card' onClick={onClick}>
            <img
                className='bind-card-icon'
                src="/image/modem/bind_card_icon.svg"
                title="Требуется обновление"
                width="25px"
                alt=""
            />
        </div>
    )
}

export default ConsoleBindCard;